<h1 class="save-line-head">Plugin</h1>

<div class="menu-row">
  @for (plugin of plugins; track plugin) {
    @if (plugin.plugin_versions.length === 0) {
      <a
        class="menu-link"
        role="button"
        tabindex="0"
        (click)="downloadPlugin(plugin.file)"
        (keydown.enter)="downloadPlugin(plugin.file)"
        (keydown.space)="downloadPlugin(plugin.file)"
      >
        <mat-card class="menu-card">
          <div class="menu-content">
            @if (plugin.icon) {
              <img
                [src]="getIconUrl(plugin.icon)"
                width="30px"
                alt=""
                class="start-icon"
              />
            }
            <span class="label">{{ plugin.title_version }}</span>
            <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
          </div>
        </mat-card>
      </a>
    }

    @if (plugin.plugin_versions.length > 0) {
      <a
        class="menu-link"
        [routerLink]="[plugin.title_version | lowercase, plugin.id]"
      >
        <mat-card class="menu-card">
          <div class="menu-content">
            @if (plugin.icon) {
              <img
                [src]="getIconUrl(plugin.icon)"
                width="30px"
                alt=""
                class="start-icon"
              />
            }
            <span class="label">{{ plugin.title_version }}</span>
            <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
          </div>
        </mat-card>
      </a>
    }
  }
</div>
